module.exports = __webpack_public_path__ + "img/01.dc4d4bfd.jpg";